(function ($) {
  'use strict';

  var timeout;

  var setActive = function ($element) {
    $element.siblings().removeClass('shown');
    $element.addClass('shown');
    if (!$element.data('stretched') && $.fn.stretchImages) {
      $element.data('stretched', true);
      $element.one(
        'transitionend oTransitionEnd webkitTransitionEnd',
        function (e) {
          $(e.currentTarget).off(
            'transitionend oTransitionEnd webkitTransitionEnd'
          );
          $(e.currentTarget).stretchImages('article');
        }
      );
    }
  };

  $(document).ready(function () {
    var $article = $('section.widget .article-list article');

    $article.on('touchend', function (e) {
      if (e.cancelable) {
        var $element = $(e.currentTarget);
        if (!$element.hasClass('shown')) {
          e.preventDefault();
          setActive($element);
        }
      }
    });

    $article.on('mouseenter', function (e) {
      if (timeout) {
        clearTimeout(timeout);
      }

      timeout = setTimeout(
        function () {
          setActive($(this));
        }.bind(this),
        200
      );
    });

    $('section.widget .article-list').each(function () {
      var $element = $(this).find('article:first-child').filter(':visible');
      setActive($element);
      if ($.fn.stretchImages) {
        $element.data('stretched', true);
        $($element).stretchImages('article');
      }
    });
  });
}).bind(window)(jQuery);
